import { PostFilter } from "@/types/filter/postFilter";
import { Store } from "vuex";
import { ActiveFilterFieldOptions, namespace as contentItemsFiltersNamespace } from "../modules/contentItems/contentItemsFilters";
import { ContentItemFilterField, ContentItemFilterFieldOption } from "../../types/filter/contentItemFilterField";
import { PostFilterField } from "@/types/filter/postFilterField";

export class ContentItemFilterStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the last used filter  */
    public get filter(): PostFilter {
        return this.store.getters[`${contentItemsFiltersNamespace}/filter`];
    }

    /** Gets the filter ID */
    public get filterId(): string {
        return this.store.getters[`${contentItemsFiltersNamespace}/filterId`];
    }

    /** Gets the filter fields */
    public get filterFields(): ContentItemFilterField[] {
        return this.store.getters[`${contentItemsFiltersNamespace}/filterFields`];
    }

    /** Gets the active filter options */
    public get activeFilters(): ActiveFilterFieldOptions {
        return this.store.getters[`${contentItemsFiltersNamespace}/activeFilterOptions`];
    }

    /** Updates last used filter  */
    public updateLastUsedFilter(id: string, filter: PostFilter): void {
        return this.store.commit(`${contentItemsFiltersNamespace}/filter`, { id, filter });
    }
    /**Loads the filter fields */
    public async loadFilterFields(filterId: string): Promise<ContentItemFilterField[]> {
        return this.store.dispatch(`${contentItemsFiltersNamespace}/loadFilterFields`, filterId);
    }

    /** Add filter field with filter option to filter */
    public async postFilterFieldAsync(fieldId: string, option: ContentItemFilterFieldOption): Promise<boolean> {
        return this.store.dispatch(`${contentItemsFiltersNamespace}/postFilterFieldAsync`, {
            fieldId: fieldId,
            option: option
        });
    }

    /** Delete filter field  from filter */
    public async deleteFilterFieldAsync(fieldId: string): Promise<boolean> {
        return this.store.dispatch(`${contentItemsFiltersNamespace}/deleteFilterFieldAsync`, fieldId);
    }
}
